export const masterDataSources = [
    "CSV_FROM_S3",
    "CSV_FROM_SFTP",
    "ODOO",
    "SAP_B1",
    "REFLEX_PIM",
    "NETSUITE",
    "EPICOR",
    "ORDERWISE",
    "MSSQL",
    "HAUFE_X360",
    "SUCO",
    "GEHR",
    "UTZ",
    "WIKA",
] as const;
